import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectVideo extends PageObject {
  video: string;
  border: boolean;

  constructor(obj: PageObjectVideo = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Video;

    if (obj == null) {
      this.video = "";
      this.border = true;
    } else {
      this.video = obj.video;
      this.border = obj.border;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Video", OBJECTPROPERTYTYPE.Text));
    let border = new ObjectProperty("Border", OBJECTPROPERTYTYPE.List);
    border.addOption("true", "Yes");
    border.addOption("false", "No");
    list.push(border);

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Video") {
      return this.video;
    } else if (name == "Border") {
      return this.border ? "true" : "false";
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Video") {
      this.video = value;
    } else if (name == "Border") {
      this.border = value == "true";
    }
  }
}
